<footer>
  <div class="info">
    <mdcr-named-logo (click)="scrollToTheTop()" />

    <p class="info__about">About us</p>

    <mdcr-contacts />
  </div>

  <mdcr-agreements-links [hideLinks]="!isDesktop" />
</footer>
